import autopay from './autopay.reducer';

const autopayReducer = autopay;

export default autopayReducer;